import { Entity, PushKind } from 'src/utils/datahubDefaultEvent/datahubDefaultEvent.enums'
import { CommunityTypeConsume } from 'src/pages/communityHome'
import { PropsCommunity } from 'src/pages/CommunityDetails/Posts/types'
import {
  IBaseEvent,
  TryEventWithEntity,
  ViewEventWithEntity,
  ClickEventWithEntity,
  OmitActionTrigger
} from '../types'
import { BuildClickEventProps, BuildTryEventProps, BuildViewEventProps } from './types'
import { BuildBaseEventProps } from './types'

export class EventBuilder {
  private baseEventData: Omit<IBaseEvent, 'action'>

  constructor(baseEventData: Omit<IBaseEvent, 'action'>) {
    this.baseEventData = baseEventData
  }

  private getCommunityData(community: PropsCommunity) {
    return {
      communityId: community?.id ? Number(community?.id) : 0,
      communityType: CommunityTypeConsume[community?.type] ?? CommunityTypeConsume[0]
    }
  }

  private buildBaseEvent({ payload, action, community }: BuildBaseEventProps) {
    const baseEvent = {
      ...this.baseEventData,
      ...payload,
      action
    }

    if (payload.entity === Entity.COMMUNITY) {
      return {
        ...baseEvent,
        ...this.getCommunityData(community)
      }
    }

    return baseEvent
  }

  buildClickEvent({ payload, action, community }: BuildClickEventProps) {
    const baseEvent = this.buildBaseEvent({ payload, action, community })

    return baseEvent as OmitActionTrigger<ClickEventWithEntity>
  }

  buildViewEvent({ payload, action, community }: BuildViewEventProps) {
    const baseEvent = this.buildBaseEvent({ payload, action, community })

    return {
      ...baseEvent,
      pushKind: PushKind.NOT_PUSH_EVENT
    } as OmitActionTrigger<ViewEventWithEntity>
  }

  buildTryEvent({ payload, action, community }: BuildTryEventProps) {
    const baseEvent = this.buildBaseEvent({
      payload,
      action,
      community
    }) as OmitActionTrigger<TryEventWithEntity>

    return {
      ...baseEvent,
      statusCode: baseEvent.statusCode || 500
    }
  }
}
